import { userConstants } from '../constants';
import { authService } from '../services';
import { alertActions } from './';
import { toast } from 'react-toastify';


const login = (email, password, platform, navigate) => {
    const request = (user) => { return { type: userConstants.LOGIN_REQUEST, user } }
    const success = (user) => { return { type: userConstants.LOGIN_SUCCESS, user } }
    const failure = (error) => { return { type: userConstants.LOGIN_FAILURE, error } }

    return dispatch => {
        dispatch(request({ email }));

        authService.login(email, password, platform)
            .then(
                user => {
                    dispatch(success(user));
                    // if(user && user?.userRole === 4){
                    //     navigate("/applicants")
                    // }else{
                    //     navigate("/")
                    // }
                    navigate("/")

                },
                error => {
                    dispatch(failure(error.toString()));
                    toast.error(error.toString())
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

//directLogin
const directLogin = (token, navigate) => {
    const request = (user) => { return { type: userConstants.LOGIN_REQUEST, user } }
    const success = (user) => { return { type: userConstants.LOGIN_SUCCESS, user } }
    const failure = (error) => { return { type: userConstants.LOGIN_FAILURE, error } }
    return dispatch => {
        dispatch(request({ token }));

        return authService.checkAuthUser(token)
            .then(
                user => {
                    dispatch(success(user));
                    return user;
                },
                error => {
                    dispatch(failure(error.toString()));
                    navigate("/login")
                }
            );
    };
}

const logout = () => {
    authService.logout();
    return { type: userConstants.LOGOUT };
}

const sendMail = (email, host, navigate) => {
    const request = (user) => { return { type: userConstants.SENDMAIL_REQUEST, user } }
    const success = (user) => { return { type: userConstants.SENDMAIL_SUCCESS, user } }
    const failure = (error) => { return { type: userConstants.SENDMAIL_FAILURE, error } }

    return dispatch => {
        dispatch(request({ email }));

        authService.sendMail(email, host)
            .then(
                user => {
                    toast.success("Reset password link sent to your registered email");
                    dispatch(success(user));
                    navigate("/login")
                },
                error => {
                    dispatch(failure(error.toString()));
                    toast.error(error.toString())
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

const checkToken = (token) => {
    const request = (user) => { return { type: userConstants.CHECKTOKEN_REQUEST, user } }
    const success = (user) => { return { type: userConstants.CHECKTOKEN_SUCCESS, user } }
    const failure = (error) => { return { type: userConstants.CHECKTOKEN_FAILURE, error } }

    return dispatch => {
        dispatch(request({ token }));

        authService.getValidateToken(token)
            .then(
                user => {
                    dispatch(success(user));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

const ChangePassword = (password, confirmPassword, token, navigate) => {
    const request = (user) => { return { type: userConstants.CHANGEPASSWORD_REQUEST, user } }
    const success = (user) => { return { type: userConstants.CHANGEPASSWORD_SUCCESS, user } }
    const failure = (error) => { return { type: userConstants.CHANGEPASSWORD_FAILURE, error } }

    return dispatch => {
        dispatch(request({ password }));

        authService.ChangePassword(password, confirmPassword, token)
            .then(
                user => {
                    toast.success("Password reset successful")
                    dispatch(success(user));
                    // navigate("/login")
                    navigate("/login")
                },
                error => {
                    dispatch(failure(error.toString()));
                    toast.error(error.toString())
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

const getProfile = () => {
    const request = () => {
        return { type: userConstants.GETPROFILE_REQUIEST };
    };
    const success = (profile) => {
        return { type: userConstants.GETPROFILE_SUCCESS, profile };
    };
    const failure = (error) => {
        return { type: userConstants.GETPROFILE_FAILURE, error };
    };

    return (dispatch) => {
        dispatch(request());

        return authService
            .getProfile()
            .then((profile, error) => {
                if (profile) {
                    dispatch(success(profile));
                    return profile;
                } else {
                    dispatch(failure(error.toString()));
                    return error;
                }
            });
    };
}

const updateProfile = (createData) => {
    const request = (createData) => {
        return { type: userConstants.UPDATEPROFILE_REQUIEST, createData };
    };
    const success = (profile) => {
        return { type: userConstants.UPDATEPROFILE_SUCCESS, profile };
    };
    const failure = (error) => {
        return { type: userConstants.UPDATEPROFILE_FAILURE, error };
    };

    return (dispatch) => {
        dispatch(request(createData));
        return authService.updateProfile(createData).then(
            (data) => {
                toast.success("User profile updated");
                dispatch(success(data));
                return data;
            },
            (error) => {
                toast.error(error.toString());
                dispatch(failure(error.toString()));
                return false;
            }
        );
    };
};



export const authActions = {
    login,
    logout,
    sendMail,
    checkToken,
    ChangePassword,
    directLogin,
    getProfile,
    updateProfile
};